import React from 'react';
import OauthButton from 'src/viewLayer/components/shared/OauthButton';
import BusinessButton from 'src/viewLayer/components/shared/BusinessButton';
import InterpolateLink from 'src/viewLayer/components/shared/InterpolateLink';
import { t } from 'src/viewLayer/helpers/translations';
import { usePrivacyPath, useTermsPath } from 'src/viewLayer/navigation';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { UKRAINIAN_LOCALE } from 'src/dataLayer/localData/languageCodes';
import './index.scss';

export const SocialLogin = ({ appType }) => {
  const { locale } = useRouteParamsContext();
  return (
    <div className="Oauth">
      <div className="Oauth--separator">
        <p><span>{t('login.button.or_log_in_with')}</span></p>
      </div>
      <div className="Oauth--list">
        <OauthButton appType={appType} provider="google" />
        <OauthButton appType={appType} provider="facebook" />
        <OauthButton appType={appType} provider="apple" />
      </div>
      { locale !== UKRAINIAN_LOCALE && <BusinessButton /> }
    </div>
  );
};

export const TermsAndConditions = () => {
  const termsLink = {
    name: 'termsLink',
    path: useTermsPath(),
    translation: t('login_options.legal.terms_link')
  };

  const privacyLink = {
    name: 'privacyLink',
    path: usePrivacyPath(),
    translation: t('login_options.legal.privacy_link')
  };

  return (
    <div className="privacy-terms">
      <InterpolateLink
        translation={t('login_options.legal.generic_gdpr_combined')}
        firstLink={ termsLink }
        secondLink={ privacyLink }
      />
    </div>
  );
};
